export default __webpack_public_path__ + "static/Texas-dfcaa2a9bba61ddcf8b797a4ca4b85c5.webp";